import React from "react"
import "../../style/helper.css";

class ErrorScreen extends React.Component {

    render() {
        return(
            <div className="page-main">
                <div className="page-content">
                    <p className="error-text">There was an error, please try again.</p>
                </div>
            </div>
        )
    }
}

export default ErrorScreen;